import dom from "../../../../../../dist/jsx-render/dom";

export class ArrowCreator {

    /**
     * Creates two additional HTML elements before and after.
     * It will create a horizontal arrow like structure like this: >___> from a given div.
     * The parent Element needs to have display: flex, flex-direction: row for this to work properly.
     *
     * Data attributes from the parent element (except data-stroke, data-stroke-width, data-fill) will be applied to the created svg elements, too.
     *
     * The element with the attribute data-make-arrow will also need data-stroke, data-stroke-width, data-fill.
     * @param element
     */
    public static create(element: HTMLElement) {
        let parent = element.parentElement;
        if (parent) {

            let strokeColor: string = element.getAttribute("data-stroke");
            let strokeWidth: number = parseInt(element.getAttribute("data-stroke-width"));
            let fillColor: string = element.getAttribute("data-fill");

            // create arrow inwards (left hand side)
            // the line widths at the top and bottom are multiplied by two because they are halfway outside the visible area.
            // !!!! use "viewBox" - "viewbox" will cause the element to be scaled wrong.
            let arrowInwards: HTMLElement = (<div className="arrow-inwards">
                <svg className="arrow-inwards-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <polygon points="0,0 100,0 100,50" fill={fillColor} />
                    <polygon points="0,100 100,100 100,50" fill={fillColor} />
                    <line x1="0" y1="0" x2="100" y2="0" stroke={strokeColor} stroke-width={strokeWidth * 2} vector-effect="non-scaling-stroke" />
                    <line x1="0" y1="0" x2="100" y2="50" stroke={strokeColor} stroke-width={strokeWidth} vector-effect="non-scaling-stroke" />
                    <line x1="0" y1="100" x2="100" y2="50" stroke={strokeColor} stroke-width={strokeWidth} vector-effect="non-scaling-stroke" />
                    <line x1="0" y1="100" x2="100" y2="100" stroke={strokeColor} stroke-width={strokeWidth * 2} vector-effect="non-scaling-stroke" />
                </svg>
            </div>);
            parent.insertBefore(arrowInwards, element);

            // create arrow outwards (right hand side)
            let arrowOutwards = (<div className="arrow-outwards">
                <svg className="arrow-outwards-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <polygon points="0,0 0,100 100,50" fill={fillColor} />
                    <line x1="0" y1="0" x2="100" y2="50" stroke={strokeColor} stroke-width={strokeWidth} vector-effect="non-scaling-stroke" />
                    <line x1="0" y1="100" x2="100" y2="50" stroke={strokeColor} stroke-width={strokeWidth} vector-effect="non-scaling-stroke" />
                </svg>
            </div>);

            // According to stack overflow, this will also work if the next sibling is null.
            parent.insertBefore(arrowOutwards, element.nextSibling);

            // Migrate other data-attributes from elemennt to the svg elements
            var attributes = element.getAttributeNames().filter(a => a.startsWith("data")
                && a != "data-make-arrow"
                && a != "data-stroke"
                && a != "data-stroke-width"
                && a != "data-fill");

            this.copyAttributesToSvg(attributes, arrowInwards, element);
            this.copyAttributesToSvg(attributes, arrowOutwards, element);
        }
    }

    private static copyAttributesToSvg(attributes: string[], element: HTMLElement, elementFrom: HTMLElement) {
        // Prüfen, ob das Probleme bereitet und man lieber nur bestimmte Attribute auf die SvgElemente kopiert.
        element.querySelector("svg")?.childNodes.forEach((n) => {
            var svgElem = n as SVGElement;

            for (let attr of attributes) {
                svgElem.setAttribute(attr, elementFrom.getAttribute(attr));
            }
        });
    }
}